import type { NamespaceCatalog } from './index';

const catalog = {
  en: {
    sharedBy: 'Shared by {name}',
    onlyOwner: 'Only {name}',
    followersOne: 'including the person following it now',
    followersMany: 'including {count} people following it now',
    privateDescription: '{who} will see “{title}”. Everyone else loses access right away.',
    privateDescriptionFollowers:
      '{who} will see “{title}”. Everyone else loses access right away, {followers}.',
    adminNotice: '{owner} gets an Inbox update saying an admin made it private.',
    suggestedYou: 'you',
    artifactAccessChanged: 'Your access changed. Open the Artifact again to continue.',
    artifactUnavailable: 'This Artifact is no longer available to you.',
    morePeople: '{names} · others: {count}',
    addedBy: 'Added by {name}',
  },
  bg: {
    sharedBy: 'Споделено от {name}',
    onlyOwner: 'Само {name}',
    followersOne: 'включително човека, който го следва в момента',
    followersMany: 'включително {count} души, които го следват в момента',
    privateDescription: '{who} ще вижда „{title}“. Всички останали ще изгубят достъпа незабавно.',
    privateDescriptionFollowers:
      '{who} ще вижда „{title}“. Всички останали ще изгубят достъпа незабавно, {followers}.',
    adminNotice: '{owner} ще получи известие във „Входящи“, че администратор го е направил частен.',
    suggestedYou: 'вие',
    artifactAccessChanged: 'Достъпът ви се промени. Отворете артефакта отново, за да продължите.',
    artifactUnavailable: 'Този артефакт вече не е достъпен за вас.',
    morePeople: '{names} · още хора: {count}',
    addedBy: 'Добавено от {name}',
  },
  hr: {
    sharedBy: 'Podijelio/la: {name}',
    onlyOwner: 'Samo {name}',
    followersOne: 'uključujući osobu koja ga sada prati',
    followersMany: 'uključujući {count} osoba koje ga sada prate',
    privateDescription: '{who} će vidjeti “{title}”. Svi ostali odmah gube pristup.',
    privateDescriptionFollowers:
      '{who} će vidjeti “{title}”. Svi ostali odmah gube pristup, {followers}.',
    adminNotice:
      '{owner} će dobiti obavijest u Ulaznoj pošti da je administrator artefakt učinio privatnim.',
    suggestedYou: 'vi',
    artifactAccessChanged: 'Vaš se pristup promijenio. Ponovno otvorite artefakt za nastavak.',
    artifactUnavailable: 'Ovaj vam artefakt više nije dostupan.',
    morePeople: '{names} · još osoba: {count}',
    addedBy: 'Dodao/la {name}',
  },
  cs: {
    sharedBy: 'Sdílí {name}',
    onlyOwner: 'Pouze {name}',
    followersOne: 'včetně osoby, která ho nyní sleduje',
    followersMany: 'včetně {count} lidí, kteří ho nyní sledují',
    privateDescription: '{who} uvidí „{title}“. Všichni ostatní okamžitě ztratí přístup.',
    privateDescriptionFollowers:
      '{who} uvidí „{title}“. Všichni ostatní okamžitě ztratí přístup, {followers}.',
    adminNotice:
      'Vlastníkovi {owner} se v doručené poště zobrazí upozornění, že správce nastavil artefakt jako soukromý.',
    suggestedYou: 'vy',
    artifactAccessChanged: 'Váš přístup se změnil. Znovu otevřete artefakt a pokračujte.',
    artifactUnavailable: 'Tento artefakt už pro vás není dostupný.',
    morePeople: '{names} · další osoby: {count}',
    addedBy: 'Přidal(a) {name}',
  },
  da: {
    sharedBy: 'Delt af {name}',
    onlyOwner: 'Kun {name}',
    followersOne: 'inklusive den person, der følger det nu',
    followersMany: 'inklusive {count} personer, der følger det nu',
    privateDescription: '{who} vil kunne se “{title}”. Alle andre mister adgangen med det samme.',
    privateDescriptionFollowers:
      '{who} vil kunne se “{title}”. Alle andre mister adgangen med det samme, {followers}.',
    adminNotice:
      '{owner} modtager en opdatering i Indbakke om, at en administrator gjorde det privat.',
    suggestedYou: 'dig',
    artifactAccessChanged: 'Din adgang er ændret. Åbn artefakten igen for at fortsætte.',
    artifactUnavailable: 'Denne artefakt er ikke længere tilgængelig for dig.',
    morePeople: '{names} · yderligere personer: {count}',
    addedBy: 'Tilføjet af {name}',
  },
  nl: {
    sharedBy: 'Gedeeld door {name}',
    onlyOwner: 'Alleen {name}',
    followersOne: 'inclusief de persoon die het nu volgt',
    followersMany: 'inclusief {count} mensen die het nu volgen',
    privateDescription: '{who} ziet “{title}”. Alle anderen verliezen direct hun toegang.',
    privateDescriptionFollowers:
      '{who} ziet “{title}”. Alle anderen verliezen direct hun toegang, {followers}.',
    adminNotice:
      '{owner} krijgt een Inbox-update waarin staat dat een beheerder het privé heeft gemaakt.',
    suggestedYou: 'jou',
    artifactAccessChanged: 'Je toegang is gewijzigd. Open het Artifact opnieuw om door te gaan.',
    artifactUnavailable: 'Dit Artifact is niet langer voor jou beschikbaar.',
    morePeople: '{names} · anderen: {count}',
    addedBy: 'Toegevoegd door {name}',
  },
  et: {
    sharedBy: 'Jagaja: {name}',
    onlyOwner: 'Ainult {name}',
    followersOne: 'sealhulgas inimene, kes seda praegu jälgib',
    followersMany: 'sealhulgas {count} inimest, kes seda praegu jälgivad',
    privateDescription: '{who} näeb „{title}“. Kõik teised kaotavad kohe juurdepääsu.',
    privateDescriptionFollowers:
      '{who} näeb „{title}“. Kõik teised kaotavad kohe juurdepääsu, {followers}.',
    adminNotice: '{owner} saab sisendkausta teate, et administraator muutis selle privaatseks.',
    suggestedYou: 'sina',
    artifactAccessChanged: 'Teie juurdepääs muutus. Jätkamiseks avage artefakt uuesti.',
    artifactUnavailable: 'See artefakt pole teile enam saadaval.',
    morePeople: '{names} · veel inimesi: {count}',
    addedBy: 'Lisas {name}',
  },
  fi: {
    sharedBy: 'Jakanut {name}',
    onlyOwner: 'Vain {name}',
    followersOne: 'mukaan lukien sitä nyt seuraava henkilö',
    followersMany: 'mukaan lukien {count} henkilöä, jotka seuraavat sitä nyt',
    privateDescription:
      '{who} näkee kohteen ”{title}”. Kaikki muut menettävät käyttöoikeuden heti.',
    privateDescriptionFollowers:
      '{who} näkee kohteen ”{title}”. Kaikki muut menettävät käyttöoikeuden heti, {followers}.',
    adminNotice:
      '{owner} saa Saapuneet-kansioon päivityksen, jossa kerrotaan, että ylläpitäjä teki siitä yksityisen.',
    suggestedYou: 'sinä',
    artifactAccessChanged: 'Käyttöoikeutesi muuttui. Avaa artefakti uudelleen jatkaaksesi.',
    artifactUnavailable: 'Tämä artefakti ei ole enää käytettävissäsi.',
    morePeople: '{names} · muita henkilöitä: {count}',
    addedBy: 'Lisännyt {name}',
  },
  fr: {
    sharedBy: 'Partagé par {name}',
    onlyOwner: 'Uniquement {name}',
    followersOne: 'y compris la personne qui le suit actuellement',
    followersMany: 'y compris les {count} personnes qui le suivent actuellement',
    privateDescription: '{who} verra « {title} ». Tous les autres perdent immédiatement l’accès.',
    privateDescriptionFollowers:
      '{who} verra « {title} ». Tous les autres perdent immédiatement l’accès, {followers}.',
    adminNotice:
      '{owner} reçoit une mise à jour dans sa boîte de réception indiquant qu’un administrateur l’a rendu privé.',
    suggestedYou: 'vous',
    artifactAccessChanged: 'Votre accès a changé. Rouvrez l’artefact pour continuer.',
    artifactUnavailable: 'Cet artefact ne vous est plus accessible.',
    morePeople: '{names} · autres personnes : {count}',
    addedBy: 'Ajouté par {name}',
  },
  de: {
    sharedBy: 'Geteilt von {name}',
    onlyOwner: 'Nur {name}',
    followersOne: 'einschließlich der Person, die ihm jetzt folgt',
    followersMany: 'einschließlich {count} Personen, die ihm jetzt folgen',
    privateDescription: '{who} wird „{title}“ sehen. Alle anderen verlieren sofort den Zugriff.',
    privateDescriptionFollowers:
      '{who} wird „{title}“ sehen. Alle anderen verlieren sofort den Zugriff, {followers}.',
    adminNotice:
      '{owner} erhält eine Inbox-Aktualisierung mit dem Hinweis, dass ein Admin es privat gemacht hat.',
    suggestedYou: 'Sie',
    artifactAccessChanged:
      'Ihr Zugriff hat sich geändert. Öffnen Sie das Artefakt erneut, um fortzufahren.',
    artifactUnavailable: 'Dieses Artefakt ist für Sie nicht mehr verfügbar.',
    morePeople: '{names} · weitere Personen: {count}',
    addedBy: 'Hinzugefügt von {name}',
  },
  el: {
    sharedBy: 'Κοινή χρήση από {name}',
    onlyOwner: 'Μόνο ο/η {name}',
    followersOne: 'συμπεριλαμβανομένου του ατόμου που το ακολουθεί τώρα',
    followersMany: 'συμπεριλαμβανομένων {count} ατόμων που το ακολουθούν τώρα',
    privateDescription:
      'Ο/Η {who} θα βλέπει το «{title}». Όλοι οι υπόλοιποι χάνουν αμέσως την πρόσβαση.',
    privateDescriptionFollowers:
      'Ο/Η {who} θα βλέπει το «{title}». Όλοι οι υπόλοιποι χάνουν αμέσως την πρόσβαση, {followers}.',
    adminNotice:
      'Ο/Η {owner} θα λάβει ενημέρωση στα Εισερχόμενα ότι ένας διαχειριστής το έκανε ιδιωτικό.',
    suggestedYou: 'εσύ',
    artifactAccessChanged: 'Η πρόσβασή σας άλλαξε. Ανοίξτε ξανά το Artifact για να συνεχίσετε.',
    artifactUnavailable: 'Αυτό το Artifact δεν είναι πλέον διαθέσιμο σε εσάς.',
    morePeople: '{names} · άλλα άτομα: {count}',
    addedBy: 'Προστέθηκε από {name}',
  },
  hu: {
    sharedBy: 'Megosztotta: {name}',
    onlyOwner: 'Csak {name}',
    followersOne: 'beleértve a jelenleg követő személyt',
    followersMany: 'beleértve a jelenleg követő {count} személyt',
    privateDescription:
      '„{title}” látható lesz {who} számára. Mindenki más azonnal elveszíti a hozzáférést.',
    privateDescriptionFollowers:
      '„{title}” látható lesz {who} számára. Mindenki más azonnal elveszíti a hozzáférést, {followers}.',
    adminNotice:
      '{owner} értesítést kap a Beérkező üzenetekben arról, hogy egy adminisztrátor priváttá tette.',
    suggestedYou: 'te',
    artifactAccessChanged:
      'A hozzáférésed megváltozott. Nyisd meg újra az Artifactot a folytatáshoz.',
    artifactUnavailable: 'Ez az Artifact többé nem érhető el számodra.',
    morePeople: '{names} · további személyek: {count}',
    addedBy: 'Hozzáadta: {name}',
  },
  ga: {
    sharedBy: 'Roinnte ag {name}',
    onlyOwner: 'Is le {name} amháin é',
    followersOne: 'an duine atá á leanúint anois san áireamh',
    followersMany: 'lena n-áirítear {count} duine atá á leanúint anois',
    privateDescription: 'Feicfidh {who} “{title}”. Caillfidh gach duine eile rochtain láithreach.',
    privateDescriptionFollowers:
      'Feicfidh {who} “{title}”. Caillfidh gach duine eile rochtain láithreach, {followers}.',
    adminNotice:
      'Gheobhaidh {owner} nuashonrú sa Bhosca Isteach á rá go ndearna riarthóir príobháideach é.',
    suggestedYou: 'tú',
    artifactAccessChanged:
      'Athraíodh do rochtain. Oscail an Artifact arís chun leanúint ar aghaidh.',
    artifactUnavailable: 'Níl an Artifact seo ar fáil duit a thuilleadh.',
    morePeople: '{names} · daoine eile: {count}',
    addedBy: 'Curtha leis ag {name}',
  },
  it: {
    sharedBy: 'Condiviso da {name}',
    onlyOwner: 'Solo {name}',
    followersOne: 'inclusa la persona che lo segue ora',
    followersMany: 'incluse {count} persone che lo seguono ora',
    privateDescription: "{who} vedrà “{title}”. Tutti gli altri perderanno subito l'accesso.",
    privateDescriptionFollowers:
      "{who} vedrà “{title}”. Tutti gli altri perderanno subito l'accesso, {followers}.",
    adminNotice:
      "{owner} riceverà un aggiornamento nella Posta in arrivo che informa che un amministratore l'ha reso privato.",
    suggestedYou: 'tu',
    artifactAccessChanged: "Il tuo accesso è cambiato. Riapri l'artefatto per continuare.",
    artifactUnavailable: 'Questo artefatto non è più disponibile per te.',
    morePeople: '{names} · altre persone: {count}',
    addedBy: 'Aggiunto da {name}',
  },
  lv: {
    sharedBy: 'Kopīgoja {name}',
    onlyOwner: 'Tikai {name}',
    followersOne: 'tostarp persona, kas tam pašlaik seko',
    followersMany: 'tostarp {count} cilvēku, kas tam pašlaik seko',
    privateDescription: '{who} redzēs “{title}”. Visi pārējie nekavējoties zaudēs piekļuvi.',
    privateDescriptionFollowers:
      '{who} redzēs “{title}”. Visi pārējie nekavējoties zaudēs piekļuvi, {followers}.',
    adminNotice: '{owner} saņems iesūtnē paziņojumu, ka administrators padarīja to privātu.',
    suggestedYou: 'tu',
    artifactAccessChanged:
      'Jūsu piekļuves tiesības ir mainītas. Atveriet artefaktu vēlreiz, lai turpinātu.',
    artifactUnavailable: 'Šis artefakts jums vairs nav pieejams.',
    morePeople: '{names} · vēl: {count}',
    addedBy: 'Pievienoja {name}',
  },
  lt: {
    sharedBy: 'Bendrino {name}',
    onlyOwner: 'Tik {name}',
    followersOne: 'įskaitant asmenį, kuris dabar jį seka',
    followersMany: 'įskaitant {count} žmonių, kurie dabar jį seka',
    privateDescription: '{who} matys „{title}“. Visi kiti iškart praras prieigą.',
    privateDescriptionFollowers:
      '{who} matys „{title}“. Visi kiti iškart praras prieigą, {followers}.',
    adminNotice: '{owner} gaus pranešimą į Gautuosius, kad administratorius padarė jį privatų.',
    suggestedYou: 'jūs',
    artifactAccessChanged:
      'Jūsų prieiga pasikeitė. Dar kartą atidarykite artefaktą, kad galėtumėte tęsti.',
    artifactUnavailable: 'Šis artefaktas jums nebepasiekiamas.',
    morePeople: '{names} · dar {count} žmonių',
    addedBy: 'Pridėjo {name}',
  },
  mt: {
    sharedBy: 'Maqsuma minn {name}',
    onlyOwner: '{name} biss',
    followersOne: 'inkluża l-persuna li qed issegwih issa',
    followersMany: 'inklużi {count} persuni li qed isegwuh issa',
    privateDescription: '{who} se jara “{title}”. Kulħadd ieħor jitlef l-aċċess minnufih.',
    privateDescriptionFollowers:
      '{who} se jara “{title}”. Kulħadd ieħor jitlef l-aċċess minnufih, {followers}.',
    adminNotice:
      '{owner} jirċievi aġġornament fl-Inbox li jgħid li amministratur għamilha privata.',
    suggestedYou: 'int',
    artifactAccessChanged: 'L-aċċess tiegħek inbidel. Iftaħ l-Artifact mill-ġdid biex tkompli.',
    artifactUnavailable: 'Dan l-Artifact m’għadux disponibbli għalik.',
    morePeople: '{names} · persuni oħra: {count}',
    addedBy: 'Miżjud minn {name}',
  },
  pl: {
    sharedBy: 'Udostępnił(a) {name}',
    onlyOwner: 'Tylko {name}',
    followersOne: 'w tym osoba, która teraz go obserwuje',
    followersMany: 'w tym {count} osób, które teraz go obserwują',
    privateDescription: '{who} zobaczy „{title}”. Wszyscy inni natychmiast stracą dostęp.',
    privateDescriptionFollowers:
      '{who} zobaczy „{title}”. Wszyscy inni natychmiast stracą dostęp, {followers}.',
    adminNotice:
      '{owner} otrzyma aktualizację w Skrzynce odbiorczej z informacją, że administrator ustawił artefakt jako prywatny.',
    suggestedYou: 'Ciebie',
    artifactAccessChanged:
      'Twój dostęp został zmieniony. Otwórz artefakt ponownie, aby kontynuować.',
    artifactUnavailable: 'Ten artefakt nie jest już dla Ciebie dostępny.',
    morePeople: '{names} · pozostałe osoby: {count}',
    addedBy: 'Dodano przez {name}',
  },
  pt: {
    sharedBy: 'Compartilhado por {name}',
    onlyOwner: 'Apenas {name}',
    followersOne: 'incluindo a pessoa que o segue agora',
    followersMany: 'incluindo {count} pessoas que o seguem agora',
    privateDescription:
      '{who} verá “{title}”. Todas as outras pessoas perderão o acesso imediatamente.',
    privateDescriptionFollowers:
      '{who} verá “{title}”. Todas as outras pessoas perderão o acesso imediatamente, {followers}.',
    adminNotice:
      '{owner} receberá uma atualização na Caixa de entrada informando que um administrador tornou isso privado.',
    suggestedYou: 'você',
    artifactAccessChanged: 'Seu acesso foi alterado. Abra o Artifact novamente para continuar.',
    artifactUnavailable: 'Este Artifact não está mais disponível para você.',
    morePeople: '{names} · outras pessoas: {count}',
    addedBy: 'Adicionado por {name}',
  },
  ro: {
    sharedBy: 'Partajat de {name}',
    onlyOwner: 'Doar {name}',
    followersOne: 'inclusiv persoana care îl urmărește acum',
    followersMany: 'inclusiv {count} persoane care îl urmăresc acum',
    privateDescription: '{who} va vedea „{title}”. Toți ceilalți își pierd imediat accesul.',
    privateDescriptionFollowers:
      '{who} va vedea „{title}”. Toți ceilalți își pierd imediat accesul, {followers}.',
    adminNotice:
      '{owner} va primi o actualizare în Inbox care spune că un administrator a făcut artefactul privat.',
    suggestedYou: 'tu',
    artifactAccessChanged:
      'Accesul tău s-a schimbat. Deschide din nou artefactul pentru a continua.',
    artifactUnavailable: 'Acest artefact nu mai este disponibil pentru tine.',
    morePeople: '{names} · alte persoane: {count}',
    addedBy: 'Adăugat de {name}',
  },
  sk: {
    sharedBy: 'Zdieľal(a): {name}',
    onlyOwner: 'Iba {name}',
    followersOne: 'vrátane osoby, ktorá ho teraz sleduje',
    followersMany: 'vrátane {count} ľudí, ktorí ho teraz sledujú',
    privateDescription: '{who} uvidí „{title}“. Všetci ostatní okamžite stratia prístup.',
    privateDescriptionFollowers:
      '{who} uvidí „{title}“. Všetci ostatní okamžite stratia prístup, {followers}.',
    adminNotice:
      '{owner} dostane aktualizáciu v doručenej pošte s informáciou, že správca nastavil súkromie.',
    suggestedYou: 'vy',
    artifactAccessChanged: 'Váš prístup sa zmenil. Znova otvorte artefakt a pokračujte.',
    artifactUnavailable: 'Tento artefakt už nie je k dispozícii.',
    morePeople: '{names} · ďalšie osoby: {count}',
    addedBy: 'Pridal(a): {name}',
  },
  sl: {
    sharedBy: 'Deli {name}',
    onlyOwner: 'Samo {name}',
    followersOne: 'vključno z osebo, ki mu trenutno sledi',
    followersMany: 'vključno z {count} osebami, ki mu trenutno sledijo',
    privateDescription: '{who} bo videl/-a »{title}«. Vsi drugi bodo takoj izgubili dostop.',
    privateDescriptionFollowers:
      '{who} bo videl/-a »{title}«. Vsi drugi bodo takoj izgubili dostop, {followers}.',
    adminNotice:
      'V nabiralnik osebe {owner} bo prispelo obvestilo, da je skrbnik artefakt nastavil kot zaseben.',
    suggestedYou: 'ti',
    artifactAccessChanged: 'Tvoj dostop se je spremenil. Znova odpri artefakt za nadaljevanje.',
    artifactUnavailable: 'Ta artefakt ti ni več na voljo.',
    morePeople: '{names} · dodatne osebe: {count}',
    addedBy: 'Dodano s strani {name}',
  },
  es: {
    sharedBy: 'Compartido por {name}',
    onlyOwner: 'Solo {name}',
    followersOne: 'incluida la persona que lo sigue ahora',
    followersMany: 'incluidas {count} personas que lo siguen ahora',
    privateDescription: '{who} verá “{title}”. Todos los demás perderán el acceso de inmediato.',
    privateDescriptionFollowers:
      '{who} verá “{title}”. Todos los demás perderán el acceso de inmediato, {followers}.',
    adminNotice:
      '{owner} recibirá una actualización en la bandeja de entrada indicando que un administrador lo hizo privado.',
    suggestedYou: 'tú',
    artifactAccessChanged: 'Tu acceso cambió. Vuelve a abrir el artefacto para continuar.',
    artifactUnavailable: 'Ya no tienes acceso a este artefacto.',
    morePeople: '{names} · otras personas: {count}',
    addedBy: 'Añadido por {name}',
  },
  sv: {
    sharedBy: 'Delas av {name}',
    onlyOwner: 'Endast {name}',
    followersOne: 'inklusive personen som följer den nu',
    followersMany: 'inklusive {count} personer som följer den nu',
    privateDescription: '{who} kommer att se ”{title}”. Alla andra förlorar åtkomsten direkt.',
    privateDescriptionFollowers:
      '{who} kommer att se ”{title}”. Alla andra förlorar åtkomsten direkt, {followers}.',
    adminNotice: '{owner} får en uppdatering i inkorgen om att en administratör gjorde den privat.',
    suggestedYou: 'du',
    artifactAccessChanged: 'Din åtkomst har ändrats. Öppna artefakten igen för att fortsätta.',
    artifactUnavailable: 'Den här artefakten är inte längre tillgänglig för dig.',
    morePeople: '{names} · ytterligare personer: {count}',
    addedBy: 'Tillagd av {name}',
  },
};

export default catalog satisfies NamespaceCatalog<keyof typeof catalog.en>;
